import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2c030c6d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=2c030c6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c030c6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c030c6d')) {
      api.createRecord('2c030c6d', component.options)
    } else {
      api.reload('2c030c6d', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2c030c6d&scoped=true", function () {
      api.rerender('2c030c6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/occupancy/Index.vue"
export default component.exports